export default __webpack_public_path__ + "static/media/IMG-2727.2d79efe1.jpg";